/**
 * A billing date in the user's language: "October 16, 2026", "16. Oktober 2026", "16 octobre 2026".
 * (The shared `formatDateLong` adds English ordinals in every language, so it isn't used here.)
 */
export const formatBillingDate = (date: string | null | undefined, locale: string): string => {
  if (!date) return "";
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? "" : new Intl.DateTimeFormat(locale, { dateStyle: "long" }).format(parsed);
};
